export default "__VITE_PUBLIC_ASSET__d6f229b6__"